/**
 * Datetime parsing helpers.
 *
 * Backend (FastAPI + SQLAlchemy) serializes naive UTC datetimes without a
 * timezone suffix, e.g. "2026-04-24T03:15:00". JavaScript's `new Date(str)`
 * treats such strings as LOCAL time, which produces an 8h offset for UTC+8
 * users and similar errors elsewhere.
 *
 * Always funnel backend datetime strings through `parseBackendDateTime` so
 * the "append Z" normalization lives in exactly one place.
 */

const TZ_SUFFIX = /[+-]\d{2}(:\d{2})?$/;

/**
 * Parse a datetime string returned by the backend.
 *
 * - If the string already has a timezone suffix (`Z` or `+08:00`), pass through.
 * - Otherwise, treat it as UTC by appending `Z`.
 */
export function parseBackendDateTime(value: string): Date {
  const normalized = value.endsWith('Z') || TZ_SUFFIX.test(value) ? value : value + 'Z';
  return new Date(normalized);
}
